<template>
	<div>
		<h3 class="mb-3">{{ $t('headlines.organizationData') }}</h3>
		<v-row dense v-if="organization">
			<v-col v-if="!$_.get(hiddenFields, 'shortName', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<l-input :disabled="disabled" v-model="organization" __path="general.shortName" />
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'fullName', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<l-input :disabled="disabled" v-model="organization" __path="general.fullName" />
			</v-col>
			<v-col v-if="!$_.get(hiddenFields, 'uid', false)" cols="12" sm="6" md="6" lg="6" xl="6">
				<l-input :disabled="disabled" v-model="organization" __path="general.uid" />
			</v-col>
		</v-row>
		<h3 class="mb-3">{{ $t('headlines.address') }}</h3>
		<v-row dense v-if="organization">
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<address-form
					:disabled="disabled"
					v-model="organization.address"
					:hiddenFields="$_.get(hiddenFields, 'address')"
				/>
			</v-col>
		</v-row>
		<h3 class="mb-3">{{ $t('headlines.contact') }}</h3>
		<v-row dense v-if="organization">
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<communication-form
					:disabled="disabled"
					v-model="organization.communication"
					:hiddenFields="$_.get(hiddenFields, 'communication')"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
// locals
import i18n from './dictionary';
// models
// components
import LInput from '@/components/base/LInput.vue';
import AddressForm from '@/components/customSchemaPartForms/addressForm/AddressForm.vue';
import CommunicationForm from '@/components/customSchemaPartForms/communicationForm/CommunicationForm.vue';
// mixins

export default {
	name: `OrganizationForm4Person`,
	components: {
		AddressForm,
		CommunicationForm,
		LInput,
	},
	mixins: [],
	i18n,
	props: {
		value: {
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
		hiddenFields: {
			type: Object,
			default: () => ({}),
		},
		personHiddenFields: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {};
	},
	computed: {
		organization: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
};
</script>
